module.exports = __webpack_public_path__ + "static/media/top-search-light-icon.ddc56f15.svg";